<template>
  <div
    class="face-overlay"
    :style="overlayStyle"
    @click="$emit('select', index)"
    @mouseenter="hovering = true"
    @mouseleave="hovering = false"
  >
  </div>
</template>

<script>
export default {
  name: "FaceOverlay",
  emits: ['select'],
  props: {
    face: {
      type: Object,
      required: true,
      // Expected: {index: 0, face_bbox: {left, top, width, height}}
    },
    index: {
      type: Number,
      required: true
    },
    showConfidence: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hovering: false
    }
  },
  computed: {
    overlayStyle() {
      const bbox = this.face.face_bbox
      return {
        position: 'absolute',
        left: `${bbox.left * 100}%`,
        top: `${bbox.top * 100}%`,
        width: `${bbox.width * 100}%`,
        height: `${bbox.height * 100}%`,
        border: this.hovering ? '3px solid rgba(255, 255, 255, 1)' : '2px dashed rgba(220, 220, 220, 0.85)',
        borderRadius: '8px',
        boxShadow: this.hovering ? '0 0 12px 2px rgba(255, 255, 255, 0.5)' : '0 0 8px 1px rgba(0, 0, 0, 0.3)',
        cursor: 'pointer',
        transition: 'all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)',
        boxSizing: 'border-box'
      }
    }
  }
}
</script>

<style scoped>
.face-overlay {
  background: transparent;
}

.face-overlay:hover {
  background: rgba(255, 255, 255, 0.1);
}
</style>
